import { Routes } from '@angular/router';
import { authGuard } from '../auth/auth.guard';
import { CompanyViewComponent } from './company-view/company-view.component';
import { CompanyEditComponent } from './company-edit/company-edit.component';
import { CustomerViewComponent } from '../customer/customer-view/customer-view.component';
import { CustomerEditComponent } from '../customer/customer-edit/customer-edit.component';

export const COMPANY_ROUTES: Routes = [
  {
    path: 'company',
    component: CompanyViewComponent,
    canActivate: [authGuard]
  },
  {
    path: 'company/edit',
    component: CompanyEditComponent,
    canActivate: [authGuard]
  },
  {
    path: 'company/employees/:id',
    component: CustomerViewComponent,
    canActivate: [authGuard]
  },
  {
    path: 'company/employees/:id/edit',
    component: CustomerEditComponent,
    canActivate: [authGuard]
  }
];
